module.exports = __webpack_public_path__ + "img/v2power_logo.250fffc3.svg";